import { ORDItem } from '../../../../apiRPC/organization';

const CHARGE_PAID_BY_AGENT_ORD_CODES = new Set(['beeline', 'ozon']);

export function shouldShowIsChargePaidByAgent(
  ord: number | undefined,
  type: string | undefined,
  category: string | null | undefined,
  ordList: ORDItem[],
): boolean {
  if (ord == null || type !== 'Intermediary' || category !== 'Initial') {
    return false;
  }
  const item = ordList.find((entry) => entry.id === ord);
  if (!item) return false;
  return CHARGE_PAID_BY_AGENT_ORD_CODES.has(item.code);
}

export function resolveIsChargePaidByAgentForApi(
  visible: boolean,
  formValue: 0 | 1 | undefined,
): boolean {
  if (!visible) return false;
  return Boolean(formValue);
}
